import project from "./project";
import datatype from "./datatype";
import dataobjects from "./dataobjects";
import dataobjectOverview from "./dataobjectOverview";
import processMessages from "./process";
import activity from "./activity";
import terminology from "./terminology";
import terminologyArea from "./terminologyArea";
import history from "./history";
import help from "./help";
import diagnostics from "./diagnostics";
import codenames from "./codenames";
import utilities from "./utilities";
import entryPage from "./entryPage";
import dependencies from "./dependencies";
import sync from "./sync";
import releases from "./releases";
import git from "./git";
import overview from "./overview";
import inUse from "./inUse";

// `designer` is still one flat namespace — renaming keys is a later step. The
// slices below partition it by feature; `npm run lint:i18n` fails if two of
// them declare the same key.
export default {
	designer: {
		...project,
		...datatype,
		...dataobjects,
		...dataobjectOverview,
		...processMessages,
		...activity,
		...terminology,
		...terminologyArea,
		...history,
		...help,
		...diagnostics,
		...codenames,
		...utilities,
		...entryPage,
		...dependencies,
		...sync,
		...releases,
		...git,
		...overview,
		...inUse,
	},
};
